var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.domVisible,
        "custom-class": _vm.dialogClass,
        "close-on-click-modal": false,
        "lock-scroll": false,
        "before-close": _vm.closeDialog
      },
      on: {
        "update:visible": function($event) {
          _vm.domVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen",
              value: _vm.loading,
              expression: "loading",
              modifiers: { fullscreen: true }
            }
          ]
        },
        [
          _c("div", { staticClass: "isCopy" }, [
            _vm.isCopy == 2
              ? _c("span", { staticClass: "warning" }, [
                  _vm._v(_vm._s(_vm.$t("CopyFailed"))),
                  _c("i", { staticClass: "el-icon-warning" })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isCopy == 1
              ? _c("span", { staticClass: "success" }, [
                  _vm._v(_vm._s(_vm.$t("CopySuccessful"))),
                  _c("i", { staticClass: "el-icon-success" })
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "expressList" }, [
            _c("li", [
              _c("span", [_vm._v(_vm._s(_vm.$t("Carrier")) + "：")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.list.ExpressName))])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", [_vm._v(_vm._s(_vm.$t("Shipping")) + "：")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("PayonDelivery")))])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", [_vm._v(_vm._s(_vm.$t("Tracking")) + "：")]),
              _vm._v(" "),
              _c("span", { staticClass: "code" }, [
                _vm._v(_vm._s(_vm.list.Express)),
                _c(
                  "i",
                  {
                    staticClass: "copy",
                    on: {
                      click: function($event) {
                        return _vm.doCopy(_vm.list.Express)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("Copy")))]
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("span", [_vm._v(_vm._s(_vm.$t("ShippingAddresses1")) + "：")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.list.Country + _vm.list.Provice + _vm.list.City) +
                    " " +
                    _vm._s(_vm.list.AddressDetail) +
                    " " +
                    _vm._s(_vm.list.ZipCode)
                ),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.list.UserName) + " " + _vm._s(_vm.list.Mobile)
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a88f2f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a88f2f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/viewexpress.vue
// module id = null
// module chunks = 